var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRingWhite = function SvgRingWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.318 10.494h5.326l4.487-6.801a1.129 1.129 0 0 0 0-1.248L28.04.61a1.122 1.122 0 0 0-.39-.37 1.071 1.071 0 0 0-.51-.141H16.894a1.047 1.047 0 0 0-.512.137c-.157.09-.29.218-.388.374l-1.127 1.872a1.129 1.129 0 0 0 0 1.248l4.45 6.764Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.999,
    cy: 29.002,
    r: 14.815,
    stroke: "currentColor",
    strokeWidth: 1.445
  })));
};
export default SvgRingWhite;